var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-container" }, [
    _c("div", { staticClass: "modal-wrap" }, [
      _c("div", { staticClass: "dialog-header" }, [
        _c("div", { staticClass: "dialog-title" }, [
          _vm._v("Remove Collaborator"),
        ]),
        _c(
          "div",
          { staticClass: "close-btn", on: { click: _vm.closeDialog } },
          [
            _c("img", {
              attrs: { src: "/img/onboarding/cancel_close.svg", alt: "" },
            }),
          ]
        ),
      ]),
      _c("div", { staticClass: "dialog-content" }, [
        _c("div", { staticClass: "replace-msg" }, [
          _vm._v(
            "\n        You are about to remove\n        " +
              _vm._s(
                _vm.collaborator.name
                  ? _vm.collaborator.name
                  : _vm.collaborator.email
              ) +
              " as a\n        collaborator on this product.\n      "
          ),
        ]),
        _c("div", { staticClass: "prompt-text" }, [
          _vm._v("Do you wish to continue?"),
        ]),
      ]),
      _c("div", { staticClass: "dialog-footer" }, [
        _c(
          "button",
          { staticClass: "grupa-white-btn", on: { click: _vm.closeDialog } },
          [_vm._v("Cancel")]
        ),
        _c(
          "button",
          {
            staticClass: "grupa-red-btn",
            staticStyle: { "margin-left": "8px" },
            on: { click: _vm.handleRemoveACollaborator },
          },
          [
            _vm._v("\n        Proceed\n        "),
            _c("img", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.spinner,
                  expression: "spinner",
                },
              ],
              staticClass: "button-spinner",
              staticStyle: { "margin-left": "20px" },
              attrs: { src: "/img/lightbox/preloader.gif" },
            }),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }